module.exports = __webpack_public_path__ + "static/media/icon-center.f91ec619.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-center.svg
// module id = 1260
// module chunks = 19